import React from "react";
import '../../assets/styles/Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard-page">
        <h1 className="page-title">Flow Dashboard</h1>
<iframe
  // src="https://qubstudentcloud-my.sharepoint.com/personal/3058524_ads_qub_ac_uk/_layouts/15/Doc.aspx?sourcedoc={9513d228-f9ca-40ea-b1c1-6471661e5723}&action=embedview&wdAllowInteractivity=False&AllowTyping=True&ActiveCell='Flow%20Dashboard'!A1&Item='Flow%20Dashboard'!A1%3AAA67&wdHideGridlines=True&wdDownloadButton=True&wdInConfigurator=True&wdInConfigurator=True"
  src="https://1drv.ms/x/c/94bf664ae74425b6/IQSK9dBIOrwdTrI-hqxw7eGVARcdKHfImvlWbTtB6_3pOcA?em=2&wdAllowInteractivity=False&AllowTyping=True&ActiveCell='Flow%20Dashboard'!A1&Item='Flow%20Dashboard'!A1%3AAA66&wdHideGridlines=True&wdDownloadButton=True&wdInConfigurator=True&wdInConfigurator=True"
  title="Flow Dashboard"
/>

</div>
  );
};

export default Dashboard;
